import MarkdownIt from 'markdown-it'
export default function () {
    const md = new MarkdownIt({
        linkify: true,
        breaks: true
    })

    md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
        const token = tokens[idx]

        // add target="_blank"
        const targetIndex = token.attrIndex('target')
        if (targetIndex < 0) {
            token.attrPush(['target', '_blank'])
        } else {
            token.attrs[targetIndex][1] = '_blank'
        }

        // add rel
        token.attrPush(['rel', 'noopener noreferrer'])

        return self.renderToken(tokens, idx, options)
    }

    return md;
}
